// extracted by mini-css-extract-plugin
module.exports = {"container":"streamStub__container___2xNIx"};